import { useState } from 'react'
import { MessageSquarePlus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '~/lib/auth-context'
import { FeedbackModal } from './FeedbackModal'

export function FeedbackButton() {
  const { user } = useAuth()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  if (!user) return null

  return (
    <>
      {/* B-new-1032: positioned via #feedback-button in app.css, sharing the
          --floating-* variables with the chatbot launcher so the two
          controls can't drift out of sync (left of the launcher, same
          vertical centre, hidden while the chat panel is open). Do not add
          Tailwind `bottom-*`/`right-*` here — that would create a second,
          driftable source of truth for this button's position. */}
      <button
        id="feedback-button"
        onClick={() => setOpen(true)}
        className="z-[60] flex items-center gap-2 px-3 py-2 bg-[#0f0f15] border border-[#00f0ff]/40 text-[#00f0ff] text-xs font-mono uppercase tracking-wider hover:bg-[#00f0ff]/10 hover:border-[#00f0ff] transition-colors shadow-lg"
        aria-label={t('feedback.buttonLabel')}
      >
        <MessageSquarePlus size={14} />
        <span className="hidden sm:inline">{t('feedback.buttonLabel')}</span>
      </button>
      {open && <FeedbackModal onClose={() => setOpen(false)} />}
    </>
  )
}
